<template>
  <a-row class="content-fix" type="flex">
    <a-col class="height100 flex-1">
      <a-row class="btn-row">
        <button
          class="tab-btn"
          :class="{ active: tab === 'content' }"
          @click="tab = 'content'"
        >
          <a-icon type="project" />Content
        </button>
      </a-row>

      <div v-show="tab === 'content'" class="main-tabs" type="card">
        <!-- Year Picker -->
        <a-row align="middle" class="flex-baseline input-area">
          <a-col
            :span="6"
            style="text-align: right; padding-right: 8px; color: #666"
          >
            Yil (YYYY):
          </a-col>
          <a-col :span="12">
            <a-date-picker
              v-model="form.year"
              :picker="'year'"
              format="YYYY"
              placeholder="Select year (YYYY)"
              style="width: 100%"
              @change="onYearChange"
            />
            <div v-if="yearError" style="color: red; font-size: 12px">
              Please select a valid year.
            </div>
          </a-col>
        </a-row>

        <!-- Select quarter -->
        <a-row align="middle" class="flex-baseline">
          <a-col
            :span="6"
            style="text-align: right; padding-right: 8px; color: #666"
          >
            Chorak:
          </a-col>
          <a-col :span="12">
            <a-select v-model="form.quarter" style="width: 100%">
              <a-select-option
                v-for="option in quarterProps"
                :key="option.id"
                :value="option.id"
              >
                {{ option.value[[$i18n.locale]] }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>

        <!-- File Upload -->
        <a-row align="middle" class="flex-baseline">
          <a-col :span="6" style="text-align: right; padding-right: 8px">
            Fayl:
          </a-col>
          <a-col :span="12">
            <a-button type="primary" @click="$refs.documentRef.click()">
              <a-icon type="upload" />Upload File
            </a-button>
            <input
              ref="documentRef"
              accept=".xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf"
              hidden
              type="file"
              @change="handleDocumentInput"
            />

            <!-- Show Selected File Name -->
            <div v-if="fileName" style="margin-top: 10px">
              <strong>Selected File:</strong> {{ fileName }}
            </div>

            <!-- Show Existing File Link (if applicable) -->
            <div v-if="form.file" style="margin-top: 10px">
              <a :href="form.file" target="_blank" style="color: #1890ff">
                <a-icon type="link" />Open Uploaded File
              </a>
            </div>
          </a-col>
        </a-row>

        <!-- Buttons -->
        <a-row style="margin-top: 20px">
          <a-col :span="6" />
          <a-col :span="12">
            <a-row>
              <a-button style="margin-right: 10px" @click="$router.go(-1)">
                <a-icon type="close" />Cancel
              </a-button>
              <a-button
                type="primary"
                :disabled="yearError || !form.file"
                @click="submitData"
              >
                <a-icon type="check" />Save
              </a-button>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import moment from "moment"

export default {
  data() {
    return {
      form: {
        file: null, // Single file
        year: null, // YYYY format
        quarter: null // YYYY format
      },
      fileName: "", // To display the selected file name
      tab: "content",
      yearError: false,

      quarterProps: [
        {
          value: {
            oz: "1-чорак",
            uz: "1-chorak",
            ru: "1-й квартал",
            en: "1st quarter"
          },
          id: 1
        },
        {
          value: {
            oz: "2-чорак",
            uz: "2-chorak",
            ru: "2-й квартал",
            en: "2nd quarter"
          },
          id: 2
        },
        {
          value: {
            oz: "3-чорак",
            uz: "3-chorak",
            ru: "3-й квартал",
            en: "3rd quarter"
          },
          id: 3
        },
        {
          value: {
            oz: "4-чорак",
            uz: "4-chorak",
            ru: "4-й квартал",
            en: "4th quarter"
          },
          id: 4
        }
      ]
    }
  },
  methods: {
    onYearChange(date) {
      this.form.year = date // Store the moment object
      this.yearError = !date // Set error if no date is selected
      if (this.yearError) {
        this.$message.warning("Please select a valid year.")
      }
    },

    handleDocumentInput(event) {
      const file = event.target.files[0]
      if (file) {
        this.form.file = file
        this.fileName = file.name
        this.$refs.documentRef.value = "" // Reset file input to allow re-selection
      }
    },

    async submitData() {
      if (this.yearError) {
        this.$message.error("Please fix the year format before submitting.")
        return
      }

      if (!this.form.file) {
        this.$message.warning("Please upload a file before submitting.")
        return
      }

      try {
        const formData = new FormData()
        formData.append("year", moment(this.form.year).format("YYYY")) // Format as YYYY
        formData.append("quarter", this.form.quarter)
        formData.append("file", this.form.file) // Single file

        // Make POST request to the API endpoint
        const response = await this.$api.post(
          "/admin/common/audit-control-objects/table/create/",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        )

        const { data } = response
        if (data) {
          this.$message.success("Data successfully imported")
          this.$router.push({ name: "citizenaudit" }) // Adjust the route as needed
        } else {
          this.$message.warning("Failed to import data.")
        }
      } catch (error) {
        console.error("Error submitting data:", error)
        this.$message.error("Error importing data")
      }
    }
  }
}
</script>

<style scoped>
/* Add any necessary styling here */
.content-fix {
  height: 100%;
}
.height100 {
  height: 100%;
}
.flex-1 {
  flex: 1;
}
.btn-row {
  margin-bottom: 16px;
}
.tab-btn {
  padding: 8px 16px;
  border: 1px solid #d9d9d9;
  background: #fff;
  cursor: pointer;
}
.tab-btn.active {
  background: #1890ff;
  color: #fff;
  border-color: #1890ff;
}
.main-tabs {
  padding: 16px;
  line-height: 50px;
}
.flex-baseline {
  align-items: baseline;
}
</style>
